/**
 * If the major/minor type in the record is one of the
 * selected types, then include it in the report
 * @param {Object} record
 * @param {Object} filters
 */
export function hasSelectedType(record, filters) {
    return (filters.minor && record.minor) || (filters.major && !record.minor);
}

/**
 * If the asset_id in the record is one of the
 * selected assets, then include it in the report
 * @param {Object} record
 * @param {Object} filters
 */
export function hasSelectedAssets(record, filters) {
    return filters.assetIds.size > 0 && filters.assetIds.has(record.asset_id);
}

/**
 * If the shift_id in the record is one of the
 * selected shifts, then include it in the report
 * @param {Object} record
 * @param {Object} filters
 */
export function hasSelectedShifts(record, filters) {
    return filters.shiftIds.size > 0 && filters.shiftIds.has(record.shift_id);
}

/**
 * If the planned/unplanned type in the record is one of the
 * selected types, then include it in the report
 * @param {Object} record
 * @param {Object} filters
 */
export function hasSelectedPlannedType(record, filters) {
    if (
        (filters.planned && record.planned) ||
        (filters.unplanned && !record.planned)
    ) {
        return true;
    }
    return false;
}

/**
 * If the type of loss in the record is one of the
 * selected types, then include it in the report
 * @param {Object} record
 * @param {Object} filters
 */
export function hasSelectedLossType(record, filters) {
    if (
        (filters.availability && record.type_of_loss === 'availability') ||
        (filters.performance && record.type_of_loss === 'performance')
    ) {
        return true;
    }
    return false;
}
